import { Link } from "react-router-dom";
import { ShoppingBag, Star } from "lucide-react";
import { useCart } from "../context/CartContext";
import { toast } from "sonner";
import { getProductStatus, BADGE_TONE } from "../lib/productStatus";
import { NotifyMe } from "./NotifyMe";

export function ProductCard({ product, index = 0 }) {
  const { add } = useCart();
  const status = getProductStatus(product);
  const onAdd = (e) => {
    e.preventDefault();
    if (!status.buyable) { toast.info(`${product.name} — ${status.label}`); return; }
    add(product);
    toast.success(`${product.name} added to cart${status.key === "preorder" ? " (pre-order)" : ""}`);
  };
  return (
    <Link to={`/shop/${product.id}`} data-testid={`product-card-${product.id}`}
      className="eon-card group flex flex-col animate-fade-up" style={{ animationDelay: `${index * 40}ms` }}>
      <div className="relative aspect-square overflow-hidden bg-eon-elevated">
        <img src={product.image} alt={product.name} loading="lazy"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        {product.is_eon && <span className="absolute top-3 left-3 eon-label bg-black/60 px-2 py-1">E.O.N</span>}
        {status.showBadge && (
          <span data-testid={`status-badge-${product.id}`} className={`absolute top-3 right-3 eon-label px-2 py-1 ${BADGE_TONE[status.tone]}`}>{status.label}</span>
        )}
      </div>
      <div className="p-5 flex-1 flex flex-col">
        <div className="eon-label">{product.category}</div>
        <h3 className="font-display text-lg font-bold text-eon-text mt-1 leading-snug">{product.name}</h3>
        <div className="flex items-center gap-1 mt-2 text-xs text-eon-muted">
          <Star size={12} className="text-eon-gold fill-eon-gold" /> {product.rating} · {product.review_count} reviews
        </div>
        <div className="mt-auto pt-4 flex items-center justify-between">
          <span className="font-mono text-eon-gold font-medium">${product.price?.toFixed(2)}</span>
          {status.buyable ? (
            <button onClick={onAdd} data-testid={`add-cart-${product.id}`}
              className="flex items-center gap-2 bg-eon-elevated hover:bg-eon-gold hover:text-black text-eon-text text-xs font-bold uppercase tracking-wider px-3 py-2 transition-colors">
              <ShoppingBag size={14} /> {status.cta}
            </button>
          ) : (
            <NotifyMe kind="product" itemId={product.id} itemName={product.name} label="Notify Me"
              triggerTestId={`notify-btn-${product.id}`}
              className="flex items-center gap-2 border border-eon-gold text-eon-gold text-xs font-bold uppercase tracking-wider px-3 py-2 hover:bg-eon-gold hover:text-black transition-colors" />
          )}
        </div>
      </div>
    </Link>
  );
}
